import React from 'react';
import { JiraSoftwareBoardAri } from '@atlassian/ari/jira-software/board';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import { createAri } from '@atlassian/jira-platform-ari/src/index.tsx';
import { integrationTypes } from '@atlassian/jira-share-button/src/constants.tsx';
import ShareButton from '@atlassian/jira-share-button/src/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import messages from './messages.tsx';

type Props = {
	boardId: number | string;
};

const REPORT_SHARE_CONTENT_TYPE = 'report';

export const JswShareButton = ({ boardId }: Props) => {
	const cloudId = useCloudId();
	const { formatMessage } = useIntl();

	if (!boardId) {
		return null;
	}

	const objectAri = fg('enable_atlassian_ari_for_jsw_share_button')
		? JiraSoftwareBoardAri.create({
				boardId: String(boardId),
				siteId: cloudId,
			}).toString()
		: createAri({
				resourceOwner: 'jira-software',
				cloudId,
				resourceType: 'board',
				resourceId: String(boardId),
			});

	return (
		<ShareButton
			integrationType={integrationTypes.CLASSIC_BOARD}
			triggerButtonStyle="icon-only"
			productId="jira"
			subProductId="jira-software"
			shareTitle={formatMessage(messages.shareTitle)}
			shareFormTitle={formatMessage(messages.shareFormTitle)}
			shareContentType={REPORT_SHARE_CONTENT_TYPE}
			objectAri={objectAri}
			copyTooltipText={formatMessage(messages.shareTooltipText)}
			shareFormHelperMessage={formatMessage(messages.shareHelperMessage)}
			poSpotlightShareButtonId="po-spotlight-share-button"
		/>
	);
};
